<app-link-account></app-link-account>
@if (event) {
  <div>
    <!-- Event Image -->
    <div class="row mb-3 d-flex justify-content-center">
      <!--    <img *ngIf="event.image_content == undefined"-->
      <!--         src="assets/sf-logo-start-2022.png"-->
      <!--         class="img-fluid" alt="..." style="max-width: 200px; height: auto;">-->
      @if (event.image_content !== undefined) {
        <img
          [src]="event.image_content"
          class="img-fluid rounded" alt="..." style="max-width: 500px; height: auto;">
      }
    </div>
    <!-- Event Name and Deadline -->
    <div class="row mb-3">
      <div class="col-12 text-center">
        <h1>{{ event.event_name }}</h1>
        <p class="text-center">{{ event.description }}</p>
        <p class="text-center"><i class="bi bi-clock"></i>
      {{ event.deadline | spotfightDateFormat }}</p>
    </div>
    <div class="col-12 text-center">
      <app-countdown [eventClosed]="event.closed"
        [deadline]="event.deadline"
        [withSeconds]="true"
        [timeout]="1000"
      ></app-countdown>
    </div>
  </div>
  @if (showHintForVotes) {
    <div class="alert alert-info mt-3" role="alert">
      <h4 class="alert-heading">Du hast noch keine Tipps abgegeben</h4>
      <p>Tippe jetzt und messe dich mit den anderen Spielern!</p>
    </div>
  }
  @if (!isClosed()) {
    <div>
      <app-link-account-hint></app-link-account-hint>
    </div>
  }
  <!-- Questions and Options -->
  <form>
    <fieldset [disabled]="!isEditable()">
      <div class="row">
        @for (question of event.questions; track question; let questionIndex = $index) {
          <div class="col-12 col-md-6 mb-4">
            <div class="card h-100">
              <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                {{ question.points }}<span class="visually-hidden">points</span>
              </span>
              <!-- Badge for right/wrong answer -->
              @if (event.closed && isQuestionAnsweredRight(question)) {
                <span
                  class="position-absolute top-100 start-100 translate-middle badge rounded-pill bg-success">
                  <i class="bi bi-check-lg"></i>
                </span>
              }
              @if (event.closed && !isQuestionAnsweredRight(question)) {
                <span
                  class="position-absolute top-100 start-100 translate-middle badge rounded-pill bg-danger">
                  <i class="bi bi-x-lg"></i>
                </span>
              }
              <div class="card-body">
                <h5 class="card-title mb-0">{{ question.content }}</h5>
                <small class="text-secondary">{{ question.sub_content }}</small>
                @for (answer of question.options; track answer; let answerIndex = $index) {
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="{{questionIndex}}"
                      id="q{{questionIndex}}-a{{answerIndex}}" [value]="answerIndex"
                      [(ngModel)]="question.selected"
                      >
                    <label class="form-check-label" for="q{{questionIndex}}-a{{answerIndex}}">{{ answer }}</label>
                  </div>
                }
              </div>
            </div>
          </div>
        }
        @if (isEditable()) {
          <button type="button" class="btn btn-primary mb-2 mt-2" (click)="onSubmitVotes()">Tipps
            abgeben
          </button>
        }
      </div>
    </fieldset>
  </form>
  @if (isClosed()) {
    <div>
      <h3 class="mb-2">Wertung</h3>
      <app-user-rank
        [points]="$safeNavigationMigration(userScore?.points)"
        [rank]="$safeNavigationMigration(userScore?.rank)"
        >
      </app-user-rank>
      <app-score-table [scoreboard]="scoreboard" [markWinner]="true"></app-score-table>
      <div class="row">
        @if (this.scoreboard !== undefined && this.scoreboard.last_key !== null) {
          <button class="btn btn-primary my-2 mx-auto" (click)="loadMore()">Zeig mir mehr</button>
        }
      </div>
    </div>
  }
</div>
}

